import useApi from "@/hooks/useApi";
import { useLivePreview } from "@/hooks/useLivePreview";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
export default function useFooterData() {
  const { GET } = useApi();
  const [pageData, setPageData] = useState(null);

  const { data, isLoading, error } = useQuery({
    queryKey: ["footer"],
    queryFn: () => GET("/pages/6?depth=1"),
  });

  const { data: liveData, isLoading: liveIsLoading } = useLivePreview({
    serverURL: process.env.NEXT_PUBLIC_CMS_URL,
    depth: 1,
    initialData: data,
  });

  useEffect(() => {
    if (liveData) {
      setPageData(liveData?.layout[0]);
    }
  }, [liveData]);

  return { pageData, isLoading: isLoading || liveIsLoading, error };
}
